import type { TechMeasureRecommendation } from '@/types';

export const allRecommendations: TechMeasureRecommendation[] = [
  {
    index: '01',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: '% BOD5 abatment is closely related with sludge age. So, an accurate sludge age adjustment is mandatory for reaching the BOD5 quality at the wastewater treatment plant.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '02',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: '% bCOD abatment is closely related with sludge age. So, an accurate sludge age adjustment is mandatory for reaching the COD quality at the wastewater treatment plant.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '03',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'A biological contamination of the filtering media can cause non-compliance in coliforms.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Coliform [bacteria/100 ml]']
  },
  {
    index: '04',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'A biological contamination of the filtering media can cause non-compliance in coliforms. To avoid this, a regular biocide treatment is required.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Coliform [bacteria/100 ml]']
  },
  {
    index: '05',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'A correct selection of floculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Sulfide',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'Oil and Grease',
      'COD',
      'Total-P',
      'TSS',
      'BOD5'
    ]
  },
  {
    index: '06',
    typeId: 'wastewater',
    category: ['Activated carbon filter', 'Pressure sand filter'],
    text: 'A differential pressure measurement, indicates the filter contamination. As soon as it is dirty, you should start a cleaning.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Phenol',
      'Cadmium',
      'Cobalt',
      'AOX',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '07',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'A great part of soluble colour dyes (high molecular weight and low polarity, as orange yellow dye) are expected to be retained in ACF. Isoelectric point pH value is important for the adsorption enhacement. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '08',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'A non-compliance in ammoniacal nitrogen can be due to incorrect nitrification. In the aerobic reactor nitrification occurs, that is, the conversion of ammoniacal nitrogen to nitrate. For this purpose the reactor must be acclimatized with the presence of nitrifying bacteria and the sludge age must be adequate (more than 15 days and it must be adjusted to the temperature value)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Ammonium-N']
  },
  {
    index: '09',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Activated carbon nature should be selected according to the type of chemical parameter to be controlled. Grain particle size, pore size and carbon type should be selected according to filter manufacturer recommendations',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'AOX',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Phenol',
      'Cadmium'
    ]
  },
  {
    index: '10',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Activated carbon nature should be selected according to the type of chemical parameter to be controlled. Grain particle size, pore size and carbon type should be selected according to filter manufacturer recommendations.  Check if your water composition has changed and if you need to change  the carbon type or grain particle size. Remember that polar and low molecular weight substances are weakly retained on the activated carbon pore.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5', 'Total-P']
  },
  {
    index: '11',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Activated carbon nature should be selected according to the type of chemical parameter to be controlled. Grain particle size, pore size and carbon type should be selected according to filter manufacturer recommendations. Check if your water composition has changed and if you need to change  the carbon type or grain particle size. Remember that polar and low molecular weight substances are weakly retained on the activated carbon pore.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '12',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Adsorption is an exotermic process. So, capacity of the activated carbon decreases with temperature increase. For very high temperatures, a decrease in the adsorption capacity is expected. For a current temperature range (from 10 to 30ºC) no effect is expected.  Therefore, it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Cobalt', 'Arsenic', 'Chromium (VI)', 'Cadmium']
  },
  {
    index: '13',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Adsorption is an exotermic process. So, capacity of the activated carbon decreases with temperature increase. For very high temperatures, a decrease in the adsorption capacity is expected. For a current temperature range (from 10 to 30ºC) no effect is expected.  Therefore, it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Zinc',
      'Copper',
      'Antimony',
      'Total-N',
      'Chromium, total',
      'COD',
      'Nickel',
      'Silver',
      'Total-P',
      'TSS',
      'Mercury',
      'BOD5',
      'Lead',
      'Phenol'
    ]
  },
  {
    index: '14',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Adsorption is an exotermic process. So, capacity of the activated carbon decreases with temperature increase. For very high temperatures, a decrease in the adsorption capacity is expected. For a current temperature range (from 10 to 30ºC) no effect is expected. Therefore, it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '15',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Adsorption is an exotermic process. So, capacity of the activated carbon decreases with temperature increase. For very high temperatures, a decrease in the adsorption capacity is expected. For a current temperature range (from 10 to 30ºC) no effect is expected. Therefore, it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['AOX']
  },
  {
    index: '16',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the Chromium6+ hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '17',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the Sb-Fe3+ aggregates. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Antimony']
  },
  {
    index: '18',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the arsenic hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Arsenic']
  },
  {
    index: '19',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the cadmium hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Cadmium']
  },
  {
    index: '20',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the chromium hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium, total']
  },
  {
    index: '21',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the copper hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Copper']
  },
  {
    index: '22',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the lead hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Lead']
  },
  {
    index: '23',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the mercury hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Mercury']
  },
  {
    index: '24',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the nickel hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Nickel']
  },
  {
    index: '25',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the silver hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Silver']
  },
  {
    index: '26',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'An effective flocculation is needed in order to separate the zinc hydroxides. A correct selection of flocculant and dosing is capital (Jar tests experiments are needed)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Zinc']
  },
  {
    index: '27',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Antimony can be adsorbed on Fe3+. Reagents such as polymeric ferric sulfate and ferric chloride are suitable.  pH values for the treatment from 5 to 6 are recommended. Estimation adsorption capacities are around 350 mg Sb/g Fe3+',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Antimony']
  },
  {
    index: '28',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Antimony cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Antimony']
  },
  {
    index: '29',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Antimony is biologically toxic for the activated sludge and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Antimony']
  },
  {
    index: '30',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Arsenic cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Arsenic']
  },
  {
    index: '31',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Arsenic is biologically toxic for the activated sludge at concentrations > 0,1 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Arsenic']
  },
  {
    index: '32',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Arsenic to be separated by a physicochemical treatment, must be in the oxidized state 5+ (arsenate). As3+ is not removable and should be oxydized to 5+ using current oxidants such as sodium hipochlorite.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Arsenic']
  },
  {
    index: '33',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'As5+ can be removed by coprecipitation with ferric hydroxide.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Arsenic']
  },
  {
    index: '34',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'At sand filter output TSS concentrations less than 2,5 ppm are expected (< 5 NTU).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['TSS']
  },
  {
    index: '35',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Biodegradable COD in kg/d should be according to food to mass F/M (kg bCOD/d/kgVSS) design parameter. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '36',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Cadmium can be coprecipitated with iron hydroxide at pH 6,5, or can be removed with organosulfide and lime precipitation with filtration at pH 8,5 - 10.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Cadmium']
  },
  {
    index: '37',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Cadmium cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Cadmium']
  },
  {
    index: '38',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Cadmium is biologically toxic for the activated sludge at concentrations > 1 to 10 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Cadmium']
  },
  {
    index: '39',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT).  This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '40',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT). This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['TSS']
  },
  {
    index: '41',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Check OD levels. It must be between 2 and 4 ppm ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD', 'BOD5']
  },
  {
    index: '42',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Check OD levels. It must be between 2 and 4 ppm (in nitrification step)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '43',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Check OD levels. It must be between 2 and 4 ppm in oxic step.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '44',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Check the pH value and adjust it according to the acidic/basic nature of the substances to be adsorbed: : acidic adsorbable substances will be best adsorbed at acid pH values. On the contrary alkaline adsorbable substantes will be best adsorbed at alkaline pH values. If your pH is not correct: if you need to lower the pH, add an acid reagent and if you need to increase the pH you must add a basic reagent',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'AOX',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'COD',
      'Total-P',
      'BOD5',
      'Phenol'
    ]
  },
  {
    index: '45',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation', 'Collection tank'],
    text: 'Chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Zinc', 'Oil and Grease', 'Nickel', 'Silver', 'Total-P', 'TSS', 'Mercury', 'Lead']
  },
  {
    index: '46',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation'],
    text: 'Chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Chromium, total',
      'Nickel',
      'Silver',
      'TSS',
      'Chromium (VI)',
      'BOD5',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '47',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'Chemical coagulation and flocculation processes are recommended to be operated below 30ºC.Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Arsenic']
  },
  {
    index: '48',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'Chemical coagulation and flocculation processes are recommended to be operated below 30ºC.Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '49',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Chemical coagulation works on non soluble BOD5 in the same way as TSS.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '50',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Chemical coagulation works on non soluble COD in the same way as TSS. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '51',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Chemical coagulation works on non soluble Total N in the same way as TSS. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '52',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Chromium 3+ hydroxide minimum solubility is reached at pH 7,5 using sodium hydroxide as reagent. The precipitation is sensitve from pH because of the redilution of the precipitate formed. When using lime coprecipitation allows to reach better results when operating at pH 8 and reaction is less dependent from pH.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium, total']
  },
  {
    index: '53',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Chromium 6+ is biologically toxic for the activated sludge at concentrations > 1 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '54',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Chromium VI cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '55',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Chromium to be separated by a physicochemical treatment, must be in the reduced state 3+. Cr6+ is not removable and should be reduced to 3+ using current reductors such as sodium metabisulfite, sodium thiosulfte, ferrous sulfate, etc. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '56',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Coagulation is very sensitive of pH. Aluminum requires values from 6,5 to 7,5 u. Iron from 7 to 8 u.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD', 'BOD5', 'Total-N', 'TSS']
  },
  {
    index: '57',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Coagulation is very sensitive of pH. Iron requires values from 7 to 8 u.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Sulfide']
  },
  {
    index: '58',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Coarse followed by fine screens are recommended, filtering size <1-3 mm.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Cadmium',
      'Cobalt',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Sulfide',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '59',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Cobalt is biologically toxic for the activated sludge and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Cobalt']
  },
  {
    index: '60',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Contact time should be enough (HRT) > 10 min',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Sulfide',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'pH',
      'COD',
      'Oil and Grease',
      'TSS',
      'BOD5'
    ]
  },
  {
    index: '61',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Contact time should be enough (HRT) > 15 min',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'COD',
      'Chromium, total',
      'Nickel',
      'Silver',
      'Total-P',
      'TSS',
      'Chromium (VI)',
      'Mercury',
      'BOD5',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '62',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Contact time, after intense mixing,  should be enough (HRT) > 10 min',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Total-P',
      'Chromium (VI)',
      'Mercury',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '63',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Copper can be precipitated as hydroxide using sodium hydroxide to pH 8 or using lime to pH 8-9. Better results are expected when using lime. For lower concentration effluent values, precipitation with organosulfides at pH 8,5, is recommended. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Copper']
  },
  {
    index: '64',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Copper cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Copper']
  },
  {
    index: '65',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Copper is biologically toxic for the activated sludge at concentrations > 1,0 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Copper']
  },
  {
    index: '66',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Coprecipitation and adsorption can be enhanced using a partial recicle from the bottom of the clarifier to the reaction tank.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '67',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Current process temperature in the biological reactor covers a range from 16 to 22ºC, being 18-20ºC the range recommended. Low temperatures < 16ºC will slow dramatically the biological process.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD', 'BOD5', 'Total-N', 'Total-P']
  },
  {
    index: '68',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Denitrification needs an accurate reactor design, high F/M in the reaction volume and rapid bCOD.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '69',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Due to nitrificated N within the reactor, high sludge retention time in the settler, can cause denitrification with sludge flotation by gas entrapment and TSS loss in the discharge. Final COD will be affected. An accurate recycle control and REDOX control in the recycle will help to control this item.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '70',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation', 'Collection tank'],
    text: 'Due to the mixing energy, foam can be developed. Foam suppressors are recommended. Silicon based antifoamers are not compatible with filtering synthetic membranes. Alternative: commercial products based on mixtures of esthers and salts of organic acids and salts of fatty acids in alkyl hydrocarbons.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Persistent Foam']
  },
  {
    index: '71',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Enough coagulant dosing is needed. Jar test are highly recommended.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Sulfide',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'Oil and Grease',
      'COD',
      'Total-P',
      'TSS',
      'BOD5'
    ]
  },
  {
    index: '72',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Enough coagulant/metal  precipitating agent dosing is needed. Jar test are highly recommended',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '73',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Extreme low pH values (< 2-4) will damage sand duration and stability',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'Chromium, total',
      'COD',
      'Nickel',
      'Silver',
      'Total-P',
      'TSS',
      'Chromium (VI)',
      'Mercury',
      'BOD5',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '74',
    typeId: 'wastewater',
    category: ['Activated carbon filter', 'Pressure sand filter'],
    text: 'Filter washing frequency: daily recommended',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Cadmium',
      'Cobalt',
      'AOX',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '75',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filter washing frequency: daily recommended.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Phenol', 'Total-P']
  },
  {
    index: '76',
    typeId: 'wastewater',
    category: ['Activated carbon filter', 'Pressure sand filter'],
    text: 'Filtering media can be biologically contaminated. Programmed disinfection washings are recommended.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Phenol',
      'Cadmium',
      'Cobalt',
      'AOX',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '77',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Soluble AOX present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Treated water flow data are needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['AOX']
  },
  {
    index: '78',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Soluble and adsorbable BOD5 present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Teated  water flow dqta are needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '79',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Soluble and adsorbable COD present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Treated water flow data are needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '80',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Soluble and adsorbable N present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Treated  water flow data are needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '81',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Soluble and adsorbable P present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Treated  water flow data are needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '82',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Soluble and adsorbable phenols present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Treated  water flow data are needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Phenol']
  },
  {
    index: '83',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering media capacity control is capital. Some chemical characteristic parameter present in the wastewater should be kept as a reference. And it should be tested periodically, at the input and output of the filter. Treated  water flow data is needed. Using these values operators should know the relation between: kg of the characteristic chemical parameter adsorbed per kg granular activated carbon present in the filter; in order to forecast the filtering media duration',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '84',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Filtering media duration should be controlled. For an intense use: 2 to 3 years of sand duration, is expected.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'Chromium, total',
      'COD',
      'Nickel',
      'Silver',
      'Total-P',
      'TSS',
      'Chromium (VI)',
      'Mercury',
      'BOD5',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '85',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Filtering velocity recommended: from 10 to 15 m3/h/m2',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Phenol',
      'Cadmium',
      'Cobalt',
      'AOX',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '86',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Filtering velocity recommended: from 12 to 18 m3/h/m2',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'Chromium, total',
      'COD',
      'Nickel',
      'Silver',
      'Total-P',
      'TSS',
      'Chromium (VI)',
      'Mercury',
      'BOD5',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '87',
    typeId: 'wastewater',
    category: ['Activated carbon filter', 'Pressure sand filter'],
    text: 'Fine precipitated sulfide powders will contaminate sand grains and should be avoided at the filter input. For that, previous treatment operations should be correctly operated (see unit 3: coagulation, unit 4: flocculation, unit 5: sedimentation).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Sulfide']
  },
  {
    index: '88',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Foam suppressors are recommended. Silicon based antifoamers are not compatible with filtering synthetic membranes. Alternative: commercial products based on mixtures of esthers and salts of organic acids and salts of fatty acids in alkyl hydrocarbons.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Persistent Foam']
  },
  {
    index: '89',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For BOD5 due to solid particles: Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT).  This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '90',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: Hydraulic load should be less than 1-2 m3/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '91',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: Hydraulic retention time (HRT) should be > 1  h. Recommended from 2 to 4 h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '92',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation'],
    text: 'For BOD5 due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet and mixing must be ensured',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '93',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet. A reasonable sludge inlet and sludge spread is needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '94',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: Mass load should be less than 3 kg/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '95',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For BOD5 due to solid particles: Mixing must be intense. Recommended: velocity gradient > 100 s-1 and rpm > 100. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '96',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For BOD5 due to solid particles: Mixing must be mild. Recommended: velocity gradient < 50 s-1 and rpm < 50. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '97',
    typeId: 'wastewater',
    category: ['Sedimentation tank', 'Flocculation'],
    text: 'For BOD5 due to solid particles: Sludge Volume  Index (SVI) should be <= 150 ml/g. SVI is used to describe the settling characteristics of sludge in the aeration tank in Activated Sludge Process. It is defined as the volume (in mL) occupied by 1 gram of activated sludge after settling for 30 minutes.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '98',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '99',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: Weir velocity should be < 4 m3/h/m',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '100',
    typeId: 'wastewater',
    category: ['Coagulation', 'Collection tank'],
    text: 'For BOD5 due to solid particles: chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '101',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For BOD5 due to solid particles: sludge extraction flow should guarantee that the sludge level is 1 to 2 m below clear water surface',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '102',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles. Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '103',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For COD due to solid particles: Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT).  This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '104',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: Hydraulic load should be less than 1-2 m3/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '105',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: Hydraulic retention time (HRT) should be > 1  h. Recommended from 2 to 4 h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '106',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation'],
    text: 'For COD due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet and mixing must be ensured',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '107',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet. A reasonable sludge inlet and sludge spread is needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '108',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: Mass load should be less than 3 kg/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '109',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For COD due to solid particles: Mixing must be intense. Recommended: velocity gradient > 100 s-1 and rpm > 100. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '110',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For COD due to solid particles: Mixing must be mild. Recommended: velocity gradient < 50 s-1 and rpm < 50. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '111',
    typeId: 'wastewater',
    category: ['Sedimentation tank', 'Flocculation'],
    text: 'For COD due to solid particles: Sludge Volume Index (SVI) should be <= 150 ml/g.  SVI is used to describe the settling characteristics of sludge in the aeration tank in Activated Sludge Process. It is defined as the volume (in mL) occupied by 1 gram of activated sludge after settling for 30 minutes.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '112',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '113',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: Weir velocity should be < 4 m3/h/m',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '114',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation'],
    text: 'For COD due to solid particles: chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '115',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'For COD due to solid particles: chemical coagulation and flocculation processes are recommended to be operated below 30ºC.Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '116',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For COD due to solid particles: sludge extraction flow should guarantee that the sludge level is 1 to 2 m below clear water surface',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '117',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'For Coliforms attached to clumps, fine screening can be useful. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Coliform [bacteria/100 ml]']
  },
  {
    index: '118',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For Oil and Grease due to solid particles: Mixing must be intense. Recommended: velocity gradient > 100 s-1 and rpm > 100. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '119',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Oil and Grease due to solid particles: Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '120',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For Total N contact time should be enough (HRT) > 15 min',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '121',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For Total N due to solid particles: Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT).  This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '122',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Hydraulic load should be less than 1-2 m3/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '123',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Hydraulic retention time (HRT) should be > 1  h. Recommended from 2 to 4 h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '124',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation'],
    text: 'For Total N due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet and mixing must be ensured',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '125',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet. A reasonable sludge inlet and sludge spread is needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '126',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Mass load should be less than 3 kg/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '127',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For Total N due to solid particles: Mixing must be intense. Recommended: velocity gradient > 100 s-1 and rpm > 100. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '128',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For Total N due to solid particles: Mixing must be mild. Recommended: velocity gradient < 50 s-1 and rpm < 50. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '129',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '130',
    typeId: 'wastewater',
    category: ['Sedimentation tank', 'Flocculation'],
    text: 'For Total N due to solid particles: Sludge Volume Index (SVI) should be <= 150 ml/g.  SVI is used to describe the settling characteristics of sludge in the aeration tank in Activated Sludge Process. It is defined as the volume (in mL) occupied by 1 gram of activated sludge after settling for 30 minutes.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '131',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '132',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: Weir velocity should be < 4 m3/h/m',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '133',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For Total N due to solid particles: sludge extraction flow should guarantee that the sludge level is 1 to 2 m below clear water surface',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '134',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation'],
    text: 'For Total N due to solid particles:chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '135',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'For high % BOD5 abatment low F/M design values are needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '136',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'For high concentrations, activated carbon in powder form is recommended to be used, prior to the coagulation operation.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'Chromium, total',
      'COD',
      'Nickel',
      'Silver',
      'Total-P',
      'Chromium (VI)',
      'Mercury',
      'BOD5',
      'Lead',
      'Phenol',
      'Cadmium'
    ]
  },
  {
    index: '137',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For non soluble dyes coagulated, high strength flocculants are recommended',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '138',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For non soluble dyes, coagulants based on aluminum forms such as Al polychloride, are recommended, because the adsorption capacity of Al hydroxides',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '139',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'For orthophosphate abatment, partial P will be incorporated to the new biological sludge, but chemical control can help. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '140',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: Hydraulic load should be less than 1-2 m3/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '141',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: Hydraulic retention time (HRT) should be > 1  h. Recommended from 2 to 4 h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '142',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet. A reasonable sludge inlet and sludge spread is needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '143',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: Mass load should be less than 3 kg/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '144',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '145',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: Weir velocity should be < 4 m3/h/m',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '146',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'For orthophosphate due to solid particles: sludge extraction flow should guarantee that the sludge level is 1 to 2 m below clear water surface',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '147',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For orthophosphate precipitation very high mixing intensity at the dosage point (G values between 200 and 300 second‐1) are recommended. Mixing times at high energy are generally in the range of 10 to 30 seconds. After this mixing operation current coagulation should be applied. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '148',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For orthophosphate precipitation: Camp number recommended 20.000-50.000 u. Note: Camp number (Gt) is the product resulting from the velocity gradient (G, s-1) by the hydraulic retention time (HRT).  This parameter is widely used in designing rapid mixing and flocculation processes. Accurate Camp number must be obtained by jar test experiments.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '149',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For orthophosphate precipitation: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet and mixing must be ensured',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '150',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For orthophosphate precipitation: Mixing must be mild. Recommended: velocity gradient < 50 s-1 and rpm < 50. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '151',
    typeId: 'wastewater',
    category: ['Sedimentation tank', 'Flocculation'],
    text: 'For orthophosphate precipitation: Sludge Volume  Index (SVI) should be <= 150 ml/g. SVI is used to describe the settling characteristics of sludge in the aeration tank in Activated Sludge Process. It is defined as the volume (in mL) occupied by 1 gram of activated sludge after settling for 30 minutes.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '152',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'For ortophosphate due to solid particles: Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet and mixing must be ensured',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '153',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'For total N due to solid particles: chemical coagulation and flocculation processes are recommended to be operated below 30ºC.Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '154',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'For total P due to solid particles: chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '155',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'For total-P due to solid particles: chemical coagulation and flocculation processes are recommended to be operated below 30ºC.Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '156',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Grain particle size, pore size and carbon type should be selected according to filter manufacturer recommendations. Check if your water composition has changed and if you need to change  the carbon type or grain particle size. Remember that polar and low molecular weight substances are weakly retained on the activated carbon pore.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '157',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Halogenated soluble substances are currently adsorbed on activated carbon, at low concentrations. For high concentrations, activated carbon in powder form is recommended to be used, prior to the coagulation reaction',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['AOX']
  },
  {
    index: '158',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Heavy metal traces can be adsorbed on the activated carbon grains. Mineral activated carbon is recommended. This should be considered as a by-function of the activated carbon use, but not a real treatment path. Ions are not suitable for carbon adsorption. Acidic media improves adsorption (pH from 4 to 6).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '159',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'High conductivity/salinity will deteriorate activated sludge performance and so it can affect to BOD5 performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '160',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'High conductivity/salinity will deteriorate activated sludge performance and so it can affect to COD performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '161',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'High conductivity/salinity will deteriorate activated sludge performance and so it can affect to total P performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '162',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'High conductivity/salinity will deteriorate activated sludge performance and so it can affect to total nitrogen performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '163',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'High molecular weight chemicals are best retained than low molecular weight substances. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD', 'BOD5']
  },
  {
    index: '164',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'High molecular weight nitrogen chemicals are best retained than low molecular weight substances. Low molecular weight substances as ammonia, will not be adsorbed on ACF.  ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '165',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'High molecular weight phosphorus chemicals are best retained than low molecular weight substances. Low molecular weight substances as ortophosphates, will not be adsorbed on ACF. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '166',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'High temperatures >25ºC will deteriorate the activated sludge settling and will promote not settling bacterias such as filamentous Nocardioforms. So, it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD', 'Temperature']
  },
  {
    index: '167',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'High temperatures >25ºC will deteriorate the activated sludge settling and will promote not settling bacterias such as filamentous Nocardioforms. So, to avoid TSS loss al settler discharge (and thus a BOD5 non compliance), it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '168',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'High temperatures >25ºC will deteriorate the activated sludge settling and will promote not settling bacterias such as filamentous Nocardioforms. So, to avoid TSS loss al settler discharge (and thus a Total N non compliance), it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '169',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'High temperatures >25ºC will deteriorate the activated sludge settling and will promote not settling bacterias such as filamentous Nocardioforms. So, to avoid TSS loss al settler discharge (and thus a Total P non compliance), it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '170',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'High temperatures >25ºC will deteriorate the activated sludge settling and will promote not settling bacterias such as filamentous Nocardioforms. So, to avoid TSS loss at settler discharge, it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '171',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Hydraulic load should be less than 1-2 m3/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '172',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Hydraulic retention time (HRT) should be > 1  h. Recommended from 2 to 4 h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '173',
    typeId: 'wastewater',
    category: ['Coagulation', 'Flocculation', 'Collection tank'],
    text: 'Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet and mixing must be ensured',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Cadmium',
      'Cobalt',
      'Oil and Grease',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'pH',
      'TSS',
      'Chromium (VI)',
      'Sulfide',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '174',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Hydraulic short circuit must be avoided: reactor inlet must be far from reactor outlet. A reasonable sludge inlet and sludge spread is needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '175',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'If the conductivity rises, an alternative reagent agent used for pH adjustment can be studied. High conductivity/salinity will deteriorate activated sludge performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance. Besides, sudden conductivity changes, cause afecctions on the reactor. Homogenezation and concentration equilibria is capital for a correct reactor performance.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Conductivity']
  },
  {
    index: '176',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'If the conductivity rises, an alternative reagent agent used for pH adjustment can be studied. High conductivity/salinity will deteriorate activated sludge performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance. Besides, sudden conductivity changes, cause afecctions on the reactor/secondary sedimentation. Homogenezation and concentration equilibria is capital for a correct reactor and secondary sedimentation performance.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Conductivity']
  },
  {
    index: '177',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'If the metal is difficult to precipitate, the use of special organosulfides as precipitant enhancers must be required',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Arsenic',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '178',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'If the pH increases/decreases, an alternative reagent agent used for pH adjustment can be studied. Low or high pH in the biological reactor will cause dysfunctions on the sludge settling velocity and quality. The correct range is from 7,2 to 8,2. Low pH requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent ( such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['pH']
  },
  {
    index: '179',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'If the pH increases/decreases, an alternative reagent agent used for pH adjustment can be studied. pH range in the biological reactor needs values from 7,2 to 8,2. Usually pH correction is needed. Low pH requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent ( such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['pH']
  },
  {
    index: '180',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'If the sludge does not decant well, it can generate TSS in the clarification and consequently a non-compliance in the COD can occur. To avoid non- compliance in COD, a close control of the process is mandatory, specifically V30´and SVI reactor control. Additionally, Inhibitors COD can cause serious dysfunctions in the settler performance.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '181',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'In case of pH variable flows a pH-probe is recommended and pH value used in PID.If pH increases, you must need an acid reagent and if pH decreases, you must need a basic reagent',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '182',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'It must be checked that the temperature is correct. Current process temperature in the biological reactor covers a range from 16 to 22ºC, being 18-20ºC the range recommended. Low temperatures < 16ºC will slow dramatically the biological process, so it will be necessary to have a heat exchanger or a heat pump to heat wastetawer before entering the biological reactor. On the other hand, temperatures >25 to 30ºC will affect nitrification and >30-35ºC nitrification will not be feasible.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Temperature']
  },
  {
    index: '183',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Lead can be precipitated as the carbonate by the addition of soda ash, at a pH of 9,0 - 9,5. Another alternative will be the precipitation with lime at pH 11,5.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Lead']
  },
  {
    index: '184',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Lead cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Lead']
  },
  {
    index: '185',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Lead is biologically toxic for the activated sludge at concentrations > 1,0 to 5 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Lead']
  },
  {
    index: '186',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Loss oF TSS coming from the sludge or the treated WW will increase Total P values at the discharge. So, solid control in the effluent is capital. To avoid non- compliance in total P due to the leakage of solids, a close control of the process is mandatory, specifically V30´and SVI index reactor control',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '187',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Loss of TSS coming from the sludge or the treated WW can increase Total Nitrogen values at the discharge. To avoid non- compliance in total Nitrogen, a close control of the process is mandatory, specifically V30´and SVI reactor control',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '188',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Loss of TSS coming from the sludge or the treated WW will increase BOD5 values at the discharge. To avoid non- compliance in BOD5, a close control of the process is mandatory, specifically V30´and SVI reactor control',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '189',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Loss of TSS coming from the sludge or the treated WW will increase COD values at the discharge. So, solid control in the effluent is capital (V30´ measurements and SVI should be maintained to values < 150 ml/g). To know if the COD non-compliance is due to the leakage of solids, the TSS should be analyzed in the secondary decanter outlet water and next apply the following expression: the theorical COD due to the TSS is equal to 1,46x TSS result (ppm). So, the real COD in the secondary decanter outlet water (if there is no solids leakage= COD (ppm) result-COD theoretically due to the TSS',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '190',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Low mixing air-liquid energy in channels, is recommended',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Persistent Foam']
  },
  {
    index: '191',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Low temperatures slightly decrease filtration velocity because the increase in the viscosity. On the contrary high temperatures increase filtration velocity. Filter capacity should be designed according the incidental very low or very high temperatures.  For a current temperature range (from 10 to 30ºC) no effect is expected. Therefore, it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Chromium, total', 'Arsenic']
  },
  {
    index: '192',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Low temperatures slightly decrease filtration velocity because the increase in the viscosity. On the contrary high temperatures increase filtration velocity. Filter capacity should be designed according the incidental very low or very high temperatures.  For a current temperature range (from 10 to 30ºC) no effect is expected. Therefore, it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Total-N',
      'COD',
      'Nickel',
      'Silver',
      'Total-P',
      'Chromium (VI)',
      'Mercury',
      'BOD5',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '193',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Low temperatures slightly decrease filtration velocity because the increase in the viscosity. On the contrary, high temperatures increase filtration velocity. Filter capacity should be designed according the incidental very low or very high temperatures.  For a current temperature range (from 10 to 30ºC) no effect is expected. Therefore, it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['TSS']
  },
  {
    index: '194',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Mass load should be less than 3 kg/h/m2 of net sedimentation area',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '195',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Mercury 1+ is precipitated using organosulfide precipitation or ferric hydroxide coprecipitation.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Mercury']
  },
  {
    index: '196',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Mercury cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Mercury']
  },
  {
    index: '197',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Mercury is biologically toxic for the activated sludge at concentrations > 0,1 to 1ppm and should be avoided at the settler input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Mercury']
  },
  {
    index: '198',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Mercury to be separated by precipitation, must be in the oxidized state 1+. Metallic form is not sensitive to precipitation. In case, oxidation in alkaline media pH 9 using hydrogen peroxyde is needed.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Mercury']
  },
  {
    index: '199',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'Mixing can help to neutralization using hourly wastewater flows. Mixing energy density recommended > 35 W/m3',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '200',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Mixing must be intense. Recommended: velocity gradient > 100 s-1 and rpm > 100. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Sulfide', 'TSS']
  },
  {
    index: '201',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Mixing must be intense. Recommended: velocity gradient > 100 s-1 and rpm > 100. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)', 'pH']
  },
  {
    index: '202',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Mixing must be mild. Recommended: velocity gradient < 50 s-1 and rpm < 50. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20 tank volume /h',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)', 'TSS', 'Sulfide']
  },
  {
    index: '203',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Mixing must be mild. Recommended: velocity gradient < 50 s-1 and rpm < 50. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 20 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '204',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Neutralization chemical must be carefully dosed, specially with low alkalinity wastewaters. In this case, soft or mild neutralization chemical, can be used. Such as: CO&#8322; as acidificant /Ca(OH)&#8322; or Na&#8322;CO&#8323;',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '205',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Nickel can be precipitated as hydroxide using lime to pH 10 - 11.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Nickel']
  },
  {
    index: '206',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Nickel cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Nickel']
  },
  {
    index: '207',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Nickel is biologically toxic for the activated sludge at concentrations > 1,0 to 2,5 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Nickel']
  },
  {
    index: '208',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Nitrification needs a relative high sludge age (>15d depending on reactor temperature range) and reactor temperature between >15ºC and <25ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '209',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Nitrogen non polar and high molecular weight chemical compounds (as triazines) are expected to be retained on the activated carbon pore. Pore size distribution in the commercial activated carbon, should be selected according to the chemical compound characteristics to be retained. On the contrary, polar and low molecular weight substances (as ammonia) are weakly retained on the activated carbon pore. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '210',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected (oil and grease are not soluble and not biodegradable). It should be avoided at the reactor input.Oil and grease are not biodegradable, because they are not soluble and can be the cause of serious disfuncions on the activated sludge, such as a poor oxygen transference and the presence of non settling bacteria such as filamentous.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Oil and Grease']
  },
  {
    index: '211',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected (phenols are biologically toxic and should be avoided at the  biological reactor input). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Phenol']
  },
  {
    index: '212',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'No action is expected to reduce/ increase temperature in this unit. However: capacity of the activated carbon decreases with temperature increase. For very high temperatures, a decrease in the adsorption capacity is expected. For a current temperature range (from 10 to 30ºC) no effect is expected.  Therefore, it must be checked that the temperature of the water is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Temperature']
  },
  {
    index: '213',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'No action is expected to reduce/ increase temperature in this unit. However: low temperatures slightly decrease filtration velocity because the increase in the viscosity. On the contrary high temperatures increase filtration velocity. Filter capacity should be designed according the incidental very low or very high temperatures.  For a current temperature range (from 10 to 30ºC) no effect is expected. Therefore, it must be checked that the temperature of the water is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Temperature']
  },
  {
    index: '214',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'No action is expected to reduce/ increase temperature in this unit. However:sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Temperature']
  },
  {
    index: '215',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'No action is expected to reduce/ increase temperature in this unit.However:chemical coagulation and flocculation processes are recommended to be operated below 30ºC. Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Temperature']
  },
  {
    index: '216',
    typeId: 'wastewater',
    category: ['Coagulation', 'Collection tank'],
    text: 'No action is expected to reduce/increase temperature in this unit. However: chemical coagulation and flocculation processes are recommended to be operated below 30ºC.Therefore, it must be checked that the temperature of the water prior to entering into the coagulation reactor  (in the collection tank) is less than 30ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Temperature']
  },
  {
    index: '217',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected.  Chromium 6+ is biologically toxic for the activated sludge at concentrations > 1 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '218',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Antimony is biologically toxic for the activated sludge and should be avoided at the reactor input.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Antimony']
  },
  {
    index: '219',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Arsenic is biologically toxic for the activated sludge at concentrations > 0,1 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Arsenic']
  },
  {
    index: '220',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Cadmium is biologically toxic for the activated sludge at concentrations > 1 to 10 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Cadmium']
  },
  {
    index: '221',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Cobalt is biologically toxic for the activated sludge and should be avoided at the reactor input.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Cobalt']
  },
  {
    index: '222',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Coliforms are lowered in an aerated reactor, but are not eliminated or controlled. Anyway, aerated biological treatment is not a coliform treatment procedure. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Coliform [bacteria/100 ml]']
  },
  {
    index: '223',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Copper is biologically toxic for the activated sludge at concentrations > 1,0 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Copper']
  },
  {
    index: '224',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Cyanides are biologically toxic and should be avoided at the reactor input. Cyanide inhibition level 30 ppm. Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Cyanide - Total']
  },
  {
    index: '225',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'No action is expected. Cyanides can cause deflocculation and poor settling on the activated sludge. Cyanides at biological reactor input, should be avoided.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Cyanide - Total']
  },
  {
    index: '226',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'No action is expected. It should be avoided at the reactor and secondary sedimentation input. Oil and grease will decrease the sludge density and will cause serious damage to the sludge settling quality. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Oil and Grease']
  },
  {
    index: '227',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Lead is biologically toxic for the activated sludge at concentrations > 1,0 to 5 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Lead']
  },
  {
    index: '228',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Mercury is biologically toxic for the activated sludge at concentrations > 0,1 to 1 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Mercury']
  },
  {
    index: '229',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Nickel is biologically toxic for the activated sludge at concentrations > 1,0 to 2,5 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Nickel']
  },
  {
    index: '230',
    typeId: 'wastewater',
    category: ['Activated carbon filter', 'Pressure sand filter'],
    text: 'No action is expected. Non soluble or oily substances will seriously contaminate the filtering media. These substances at the filter input, should be avoided. For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '231',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'No action is expected. Not recommended that Oil and Grease enters in the collection tank. Preferably should be separated prior homogenization. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '232',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'No action is expected. Phenols can cause deflocculation and loss of TSS in the WW discharge, affecting to COD/BOD5/Nt/Pt discharge quality. It should be avoided at the biological reactor input',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Phenol']
  },
  {
    index: '233',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Silver is biologically toxic for the activated sludge and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Silver']
  },
  {
    index: '234',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'No action is expected. Some coliforms decrease can be expected when high quality settilng and low discharge turbidity is obtained. Anyway, settling in not a coliform treatment procedure. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Coliform [bacteria/100 ml]']
  },
  {
    index: '235',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'No action is expected. Sulfide can cause deflocculation and poor settling on the activated sludge. Sulfide at biological reactor input, should be avoided. For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Sulfide']
  },
  {
    index: '236',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Total Chromium is biologically toxic for the activated sludge at concentrations > 1 to 100 ppm and should be avoided at the reactor input.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Chromium, total']
  },
  {
    index: '237',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'No action is expected. Zinc is biologically toxic for the activated sludge at concentrations > 0,3 to 5 ppm and should be avoided at the reactor input.   Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Zinc']
  },
  {
    index: '238',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'No biodegradable nitrogen or lack of technology for nitrification/denitrification will cause Total Nitrogen concentrations at the reactor and settler dicharge. On the other hand,  loss of TSS coming from the sludge or the treated WW will increase Nt values at the discharge. So, solid control in the effluent is capital (see actions for TSS parameter).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '239',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non polar and high molecular weight chemical compounds (as Polycyclic Aromatic Hydrocarbons (PAHs), such as benzo-a-pyrene) are expected to be retained on the activated carbon pore. Pore size distribution in the commercial activated carbon, should be selected according to the chemical compound characteristics  to be retained. On the contrary, polar and low molecular weight substances (as formaldehyde) are weakly retained on the activated carbon pore.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '240',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non polar and high molecular weight chemical compounds (as non-polar long-chain lipids, such as acylglycerols) are expected to be retained on the activated carbon pore. Pore size distribution in the commercial activated carbon, should be selected according to the chemical compound characteristics  to be retained. On the contrary, polar and low molecular weight substances (as methanol) are weakly retained on the activated carbon pore. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '241',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non polar and high molecular weight chemical compounds (as parathion) are expected to be retained on the activated carbon pore. Pore size distribution in the commercial activated carbon, should be selected according to the chemical compound characteristics  to be retained. On the contrary, polar and low molecular weight substances (as phosphorus trichloride) are weakly retained on the activated carbon pore. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '242',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble BOD5 at ACF filter input, must be avoided because of the filtering media contamination.The presence of contamination should be ruled out. If contamination of the filtering medium occurs, this unit will not work well causing possible non-compliance in the BOD5. Therefore, the previous coagulation + flocculation + sand filter units should be operated well to avoid the entry of non-soluble BOD5 into the ACF filter inlet',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '243',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Non soluble BOD5 is expected to be retained during the sand filtration if particle size is greater than 20-50 microns and grain size used is according to manufacturer recommendations. Therefore, it must be checked the following: the relationship between the total BOD5 and the soluble BOD5, the grain size used. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '244',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble COD at ACF filter input, must be avoided because of the filtering media contamination. The presence of contamination should be ruled out. If contamination of the filtering medium occurs, this unit will not work well causing possible non-compliance in the COD. Therefore, the previous coagulation + flocculation + sand filter units should be operated well to avoid the entry of non-soluble COD into the ACF filter inlet',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '245',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Non soluble COD is expected to be retained during the sand filtration if particle size is greater than 20-50 microns and grain size used is according to manufacturer recommendations. Therefore, it must be checked the following: the relationship between the total COD and the soluble COD, the grain size used. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '246',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble Total N at ACF filter input, must be avoided because of the filtering media contamination. The presence of contamination should be ruled out. If contamination of the filtering medium occurs, this unit will not work well causing possible non-compliance in the Total N. Therefore, the previous coagulation + flocculation + sand filter units should be operated well to avoid the entry of non-soluble Total N into the ACF filter inlet',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '247',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Non soluble Total N is expected to be retained during the sand filtration if particle size is greater than 20-50 microns and grain size used is according to manufacturer recommendations. Therefore, it must be checked the following: the relationship between the total N and the soluble N, the grain size used. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '248',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble Total P at ACF filter input, must be avoided because of the filtering media contamination.The presence of contamination should be ruled out.If contamination of the filtering medium occurs, this unit will not work well causing possible non-compliance in the phosphorus. Therefore, the previous coagulation + flocculation + sand filter units should be operated well to avoid the entry of non-soluble Total P into the ACF filter inlet',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '249',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Non soluble Total P is expected to be retained during the sand filtration if particle size is greater than 20-50 microns and grain size used is according to manufacturer recommendations. Therefore, it must be checked the following: the relationship between the total phosphorus and the soluble phosphorus and the grain size used. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '250',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Non soluble colour dyes are expected to be retained during the sand filtration if particle size is greater than 20-50 microns and grain size used is according to manufacturer recommendations. Therefore, it must be checked the following: the relationship between the total colour dyes and the soluble colour dyes, the grain size used. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '251',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble colour dyes at ACF filter input, must be avoided because of the filtering media contamination.The presence of contamination should be ruled out. If contamination of the filtering medium occurs, this unit will not work well causing possible non-compliance in the colour parameter. Therefore, the previous coagulation + flocculation + sand filter units should be operated well to avoid the entry of non-soluble colour dyes into the ACF filter inlet',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '252',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Non soluble or oily substances will cause a loss in the filter capacity and will seriously contaminate the filtering media, so they should be avoided in order to get good performance. For that, see the actions of "oil and grease" parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: [
      'Cobalt',
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '253',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble or oily substances will seriously contaminate the filtering media. In order to get avoid it (if it does not work well, this can cause a non-compliance   in the BOD5), these substances at the filter input, should be avoided. For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5', 'Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '254',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble or oily substances will seriously contaminate the filtering media. In order to get avoid it (if it does not work well, this can cause a non-compliance  in the COD), these substances at the filter input, should be avoided. For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '255',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble or oily substances will seriously contaminate the filtering media. In order to get avoid it (if it does not work well, this can cause a non-compliance in the Total N), these substances at the filter input, should be avoided. For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '256',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Non soluble or oily substances will seriously contaminate the filtering media. In order to get avoid it (if it does not work well, this can cause a non-compliance in the Total P),these substances at the filter input, should be avoided. For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Phenol', 'Total-P']
  },
  {
    index: '257',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Non-compliance in BOD5 can be due to the fact that the water (either in its entirety or a fraction of BOD5) is not biodegradable or it is slowly biodegradable. Biodegradable wastewaters shows ratios of COD/BOD5 from 2 to 3. If the ratio is lower, easy biodegradable wastewaters are considered. If the ratio is very high (more than 4,) poor WW biodegradability will be observed. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '258',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Oil and Grease traces, can be adsorbed over the flocs prior to coagulation. Intense coagulation using aluminum coagulant source such as Al polychloride is prefered. Aluminum coagulant requires values from 6,5 to 7,5 u',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '259',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Oil and Grease traces, can be flocculated when adsorbed over the flocs prior to coagulation.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '260',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Oily waters will cause a loss in the filter capacity and should be avoided in order to get good performance (if it does not work well this can cause a non-compliance   in BOD5) . For that, see the actions of "oil and grease" parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '261',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Oily waters will cause a loss in the filter capacity and should be avoided in order to get good performance (if it does not work well this can cause a non-compliance  in the Total P). For that, see the actions of "oil and grease" parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '262',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Oily waters will cause a loss in the filter capacity and should be avoided in order to get good performance (if it does not work well this can cause a non-compliance in the COD) . For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '263',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Oily waters will cause a loss in the filter capacity and should be avoided in order to get good performance (if it does not work well this can cause a non-compliance in the Total N) . For that, previous treatment operations should be correctly operated.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '264',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Oily waters will cause a loss in the filter capacity and should be avoided in order to get good performance. For that, see the actions of "oil and grease" parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '265',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Only in case of big grease clumps, fine screening can be useful.  ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '266',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Only non soluble dyes and colorants can be separated by chemical coagulation. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '267',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Only real biodegradable (bCOD) can be treated by a biological process. No biodegradable COD will be present in the wastewater treatment plant discharge. The non-biodegradable fraction (refractory COD) can not be eliminated by biological treatmentNote: Biodegradable wastewaters usually shows ratios of COD/BOD5 from 2 to 3. If the ratio is lower, easy biodegradable wastewaters are considered. If the ratio is very high (more than 4,) poor WW biodegradability will be expected. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '268',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Orthophosphate can be precipitated using: (a) ferric chloride based on a surface complexation model Fe1.6(H&#8322;PO&#8324;)(OH)3.8 / (b) As the pH increases to more than 10 using a calcium source such as Ca(OH)&#8322;, excess calcium ions will react with phosphate to precipitate hydroxylapatite [Ca&#8325;(OH)(PO&#8324;)&#8323;]',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '269',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'PID is recommended and needs to be adjusted to dosing flow',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '270',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Persistent foam usually will be increased within the aerated chambers of the activated sludge process; due to the air/sludge contact. Antifoaming commercial substances can help to foam control.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Persistent Foam']
  },
  {
    index: '271',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Phenols are expected to be adsorbed on activated carbon',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['Phenol']
  },
  {
    index: '272',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Pressure sand filter is the specific process for TSS control. TSS concentrations at filter input should be < 100-200 ppm (<200-400 NTU). In case, it must be improved the previous processes performance coagulation-flocculation-sedimentation.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['TSS']
  },
  {
    index: '273',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'Recommended mild alkaline pH values (when possible) in the collection tanks (from 7 to 8) using chemical dosing',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '274',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Reduced Chromium6+ to 3+,  hydroxide minimum solubility is reached at pH 7,5 using sodium hydroxide as reagent. The precipitation is sensitve from pH because of the redilution of the precipitate formed. When using lime coprecipitation allows to reach better results when operating at pH 8 and reaction is less dependent from pH.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '275',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'Sand filtering capacity is limited for TSS particles  20-50 microns. So, if the particle size is smaller a non-compliance in TSS can occur. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['TSS']
  },
  {
    index: '276',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregate Otherwise, the water must be heated (by a heat pump or heat exchanger for example)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Mercury']
  },
  {
    index: '277',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Nickel']
  },
  {
    index: '278',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5', 'Cadmium']
  },
  {
    index: '279',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Antimony',
      'Silver',
      'Total-P',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead'
    ]
  },
  {
    index: '280',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '281',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates.  Therefore, it must be checked that the temperature of the water is above 10ºC. Otherwise, the water must be heated (by a heat pump or heat exchanger for example)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Copper']
  },
  {
    index: '282',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC because viscosity increase causes a decreasing of the downward velocity of aggregates. Therefore, it must be checked that the temperature of the water is above 10ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Oil and Grease']
  },
  {
    index: '283',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC, because viscosity increase causes a decreasing of the downward velocity of aggregates. Therefore, it must be checked that the temperature of the water is above 10ºC.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '284',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Sedimentation processes are recommended to be operated above 10ºC, because viscosity increase causes a decreasing of the downward velocity of aggregates. Therefore, it must be checked that the temperature of the water is above 10ºC. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5', 'Total-N', 'Total-P', 'TSS']
  },
  {
    index: '285',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Silver can be coprecipitated, using alum or iron. Also, silver can be precipitated as hydroxide at pH 11.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Silver']
  },
  {
    index: '286',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Silver cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Silver']
  },
  {
    index: '287',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Silver is biologically toxic for the activated sludge and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Silver']
  },
  {
    index: '288',
    typeId: 'wastewater',
    category: ['Sedimentation tank', 'Flocculation'],
    text: 'Sludge Volume Index (SVI) should be <= 150 ml/g.  SVI is used to describe the settling characteristics of sludge in the aeration tank in Activated Sludge Process. It is defined as the volume (in mL) occupied by 1 gram of activated sludge after settling for 30 minutes.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '289',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Sludge age reactor control is dramatically affected by temperature. Sludge wasting rates should be adjusted according to reactor temperature (in terms of the Arrhenius Equation)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD', 'BOD5', 'Total-N', 'Total-P']
  },
  {
    index: '290',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Sludge extraction flow should guarantee that the sludge level is 1 to 2 m below clear water surface',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '291',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Antimony coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Antimony']
  },
  {
    index: '292',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Arsenic coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Arsenic']
  },
  {
    index: '293',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid BOD5 coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['BOD5']
  },
  {
    index: '294',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid COD coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '295',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Cadmium coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Cadmium']
  },
  {
    index: '296',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Chromium6+ coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium (VI)']
  },
  {
    index: '297',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Cobalt coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Cobalt']
  },
  {
    index: '298',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Copper coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Copper']
  },
  {
    index: '299',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Lead coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Lead']
  },
  {
    index: '300',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Mercury coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Mercury']
  },
  {
    index: '301',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Nickel coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Nickel']
  },
  {
    index: '302',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Silver coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Silver']
  },
  {
    index: '303',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Sulfide coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Sulfide']
  },
  {
    index: '304',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Total N coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-N']
  },
  {
    index: '305',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Total P coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Total-P']
  },
  {
    index: '306',
    typeId: 'wastewater',
    category: ['Bar screen'],
    text: 'Solid particles greater than 1-3 mm should be separated in order to avoid Zinc coming from solids',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Zinc']
  },
  {
    index: '307',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'Stratification within the tank must be avoided. Enough mixing energy must be applied in order to avoid sedimentation. Mixing energy density recommended > 35 W/m3',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Cadmium',
      'Cobalt',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Sulfide',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  },
  {
    index: '308',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Sudden conductivity changes, cause afecctions on the reactor. Homogenezation and concentration equilibria is capital for a correct reactor performance.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD', 'BOD5', 'Total-N', 'Total-P']
  },
  {
    index: '309',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Sulfide will be oxidized to sulfate within the aerated reactor. Inhibition levels from 50 to 100 ppm at the reactor input',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Sulfide']
  },
  {
    index: '310',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Sulfides can be precipitated and separated, using ferric chloride as coagulant.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Sulfide']
  },
  {
    index: '311',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'Sulfides precipitated using ferric chloride need the selection of a proper flocculant, because the low size of the aggregates.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Sulfide']
  },
  {
    index: '312',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Sulfite will be oxidized to sulfate within the aerated reactor. Anyway sulfite/sulfate content in the biological reactor >1.000 ppm will cause problems on the WW treatment quality.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Sulfite']
  },
  {
    index: '313',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Sulfite/sulfate content in the clarified treated WW >1.000 ppm will cause problems on the WW treatment quality.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Sulfite']
  },
  {
    index: '314',
    typeId: 'wastewater',
    category: ['Pressure sand filter'],
    text: 'TSS gives COD values, so it must be checked the TSS levels at sand filtering inlet. TSS concentrations at filter input should be < 100-200 ppm (<200-400 NTU). In case, it must be improved the previous processes performance coagulation-flocculation-sedimentation (see TSS parameter).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '315',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'TSS loss at settler discharge and thus, a non-compliance in BOD5 (because of TSS content) can be due to: sludge deflocculation or sludge disfunction performance. The deflocculation is often due to toxic effects in the bological reactor (lack of dissolved oxygen, presence of inhibitors or toxic substances in the wastewater such as AOX and phenols, etc). The TSS loss, additionally, can be due to the presence of filamentous bacteria. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '316',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'TSS loss at settler discharge and thus, a non-compliance in COD (because of TSS content) can be due to: sludge deflocculation or sludge disfunction performance. The deflocculation is often due to toxic effects in the bological reactor (lack of dissolved oxygen, presence of inhibitors or toxic substances in the wastewater such as AOX and phenols, etc). The TSS loss, additionally, can be due to the presence of filamentous bacteria. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '317',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'TSS loss at settler discharge and thus, a non-compliance in Total Nitrogen (because of TSS content) can be due to: sludge deflocculation or sludge disfunction performance. The deflocculation is often due to toxic effects in the biological reactor (lack of dissolved oxygen, presence of inhibitors or toxic substances in the wastewater such as AOX and phenols, etc). The TSS loss, additionally, can be due to the presence of filamentous bacteria. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '318',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'TSS loss at settler discharge and thus, a non-compliance in total P (because of TSS content) can be due to: sludge deflocculation or sludge disfunction performance. The deflocculation is often due to toxic effects in the bological reactor (lack of dissolved oxygen, presence of inhibitors or toxic substances in the wastewater such as AOX and phenols, etc). The TSS loss, additionally, can be due to the presence of filamentous bacteria. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '319',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)', 'Arsenic', 'Sulfide']
  },
  {
    index: '320',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Temperature for correct settling is recommended below 30ºC. Therefore, it must be checked that the temperature is correct. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '321',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss al settler discharge due to phenol inhibition check phenol levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '322',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a BOD5 non compliance) due to AOX inhibition check AOX levels in the previous unit (aerobic reactor).  Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '323',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a BOD5 non compliance) due to cyanides inhibition check cyanide levels in the previous unit (aerobic reactor). Cyanides at biological reactor input, should be avoided',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '324',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a BOD5 non compliance) due to phenol inhibition check phenol levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '325',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a BOD5 non compliance) it must be checked the pH. Low or high pH  will cause dysfunctions on the sludge settling velocity and quality. The correct range is from 7,2 to 8,2. Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent ( such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '326',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a BOD5 non compliance) oil and grease should be avoided at the reactor input.Oil and grease will decrease the sludge density and will cause serious damage to the sludge settling quality. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '327',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a BOD5 non compliance) sulfide should be avoided. Sulfide can cause deflocculation and poor settling on the activated sludge. Sulfide at biological reactor input, should be avoided. For that, previous treatment operations should be correctly operated. See all actions in "sulfide parameter".',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '328',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a COD non compliance) due to AOX inhibition check AOX levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '329',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a COD non compliance) due to cyanides inhibition check cyanide levels in the previous unit (aerobic reactor). Cyanides at biological reactor input, should be avoided',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '330',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a COD non compliance) due to phenol inhibition check phenol levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '331',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a COD non compliance) it must be checked the pH. Low or high pH  will cause dysfunctions on the sludge settling velocity and quality. The correct range is from 7,2 to 8,2. Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent ( such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '332',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a COD non compliance) oil and grease should be avoided at the reactor input. Oil and grease will decrease the sludge density and will cause serious damage to the sludge settling quality. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '333',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a COD non compliance) sulfide should be avoided. Sulfide can cause deflocculation and poor settling on the activated sludge. Sulfide at biological reactor input, should be avoided. For that, previous treatment operations should be correctly operated. See all actions in "sulfide parameter".',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '334',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a TSS non compliance due to solids content) it must be checked the pH. Low or high pH will cause dysfunctions on the sludge settling velocity and quality. The correct range is from 7,2 to 8,2. Low pH requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent (such as sulfuric acid or hydrochloric acid).',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '335',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a TSS non compliance) oil and grease should be avoided at the reactor input. Oil and grease will decrease the sludge density and will cause serious damage to the sludge settling quality. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '336',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total Nitrogen non compliance) due to AOX inhibition check AOX levels in the previous unit (aerobic reactor).  Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '337',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total Nitrogen non compliance) due to cyanides inhibition check cyanide levels in the previous unit (aerobic reactor). Cyanides at biological reactor input, should be avoided',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '338',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total Nitrogen non compliance) due to phenol inhibition check phenol levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '339',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total Nitrogen non compliance) it must be checked the pH. Low or high pH  will cause dysfunctions on the sludge settling velocity and quality. The correct range is from 7,2 to 8,2. Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent (such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '340',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total Nitrogen non compliance) oil and grease should be avoided at the reactor input. Oil and grease will decrease the sludge density and will cause serious damage to the sludge settling quality. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '341',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total Nitrogen non compliance) sulfide should be avoided. Sulfide can cause deflocculation and poor settling on the activated sludge. Sulfide at biological reactor input, should be avoided. For that, previous treatment operations should be correctly operated. See all actions in "sulfide parameter".',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '342',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a Total P non compliance because of solids content) due to cyanides inhibition check cyanide levels in the previous unit (aerobic reactor). Cyanides at biological reactor input, should be avoided',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '343',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a total P non compliance) due to AOX inhibition check AOX levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '344',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a total P non compliance) due to phenol inhibition check phenol levels in the previous unit (aerobic reactor). Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '345',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a total P non compliance) it must be checked the pH. Low or high pH  will cause dysfunctions on the sludge settling velocity and quality. The correct range is from 7,2 to 8,2. Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent ( such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '346',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a total P non compliance) oil and grease should be avoided at the reactor input.Oil and grease will decrease the sludge density and will cause serious damage to the sludge settling quality. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '347',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge (and thus a total P on compliance) sulfide should be avoided. Sulfide can cause deflocculation and poor settling on the activated sludge. Sulfide at biological reactor input, should be avoided at the reactor imput. For that, previous treatment operations should be correctly operated. See all actions in "sulfide parameter".',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '348',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge and thus, a non-compliance in TSS can be due to: sludge deflocculation or sludge disfunction performance. The deflocculation is often due to toxic effects in the biological reactor (lack of dissolved oxygen, presence of inhibitors or toxic substances in the wastewater such as AOX and phenols, cyanides, etc). The TSS loss, additionally, can be due to the presence of filamentous bacteria. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '349',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge due to AOX inhibition check AOX levels in the previous unit (aerobic reactor).  Inhibition levels are observed from 50 to 200 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '350',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge due to cyanides inhibition check cyanide levels in the previous unit (aerobic reactor). Cyanides at biological reactor input, should be avoided',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '351',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge, SLUDGE VOLUME INDEX (SVI) needs to be close controlled and should be maintained to values < 150 ml/g. SVI is used to describe the settling characteristics of sludge in the aeration tank in Activated Sludge Process. It is defined as the volume (in mL) occupied by 1 gram of activated sludge after settling for 30 minutes.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N', 'COD', 'Total-P', 'TSS', 'BOD5']
  },
  {
    index: '352',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge, it must be checked that the conductivity of the water is correct. High conductivity/salinity will deteriorate activated sludge settling performance. Chlorides at reactor input should be <10.000 ppm and sulfates < 1.000 ppm for a correct performance',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '353',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler discharge, it must be checked that the conductivity of the water is correct. Sudden conductivity changes, cause afecctions in the settler. Homogenezation and concentration equilibria is capital for a correct reactor performance.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '354',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'To avoid TSS loss at settler sulfide should be avoided. Sulfide can cause deflocculation and poor settling on the activated sludge. Sulfide at biological reactor input, should be avoided. For that, previous treatment operations should be correctly operated. See all actions in "sulfide parameter".',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '355',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid an increase in total solids at biological reactor input, the previous steps must work well (a correct operation of bar screen and coagulation/ floculation unit operations). Big excess of TSS can cause dramatic fall in the oxygen consumption (SOUR: specific oxygen uptake rate). This can be dangerous for the reactor stability. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '356',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid an increase in total solids at biological reactor input, the previous steps must work well (a correct operation of bar screen and coagulation/ floculation unit operations). TSS at biological reactor input should be taken into account for wasting sludge rate adjustment. In order not to overcharge the reactor with solids coming from the waste water, TSS concentrations at biological reactor input shouldn´t be > 100 ppm. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '357',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid dysfunctions on BOD5 performance, oil and grease should be avoided at the reactor input.Oil and grease are not biodegradable, because they are not soluble and can be the cause of serious dysfunctions on the activated sludge, such as a poor oxygen transference and the presence of non settling bacteria such as filamentous.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '358',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid dysfunctions on COD performance, oil and grease should be avoided at the reactor input.Oil and grease are not biodegradable, because they are not soluble and can be the cause of serious dysfunctions on the activated sludge, such as a poor oxygen transference and the presence of non settling bacteria such as filamentous.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '359',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid dysfunctions on TSS performance, oil and grease should be avoided at the reactor input. Oil and grease are not biodegradable, because they are not soluble and can be the cause of serious dysfunctions on the activated sludge, such as a poor oxygen transference and the presence of non settling bacteria such as filamentous.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '360',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid dysfunctions on total P performance, oil and grease should be avoided at the reactor input. Oil and grease are not biodegradable, because they are not soluble and can be the cause of serious dysfunctions on the activated sludge, such as a poor oxygen transference and the presence of non settling bacteria such as filamentous.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '361',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid dysfunctions on total nitrogen performance, oil and grease should be avoided at the reactor input.Oil and grease are not biodegradable, because they are not soluble and can be the cause of serious dysfunctions on the activated sludge, such as a poor oxygen transference and the presence of non settling bacteria such as filamentous.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '362',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid non- compliance in BOD5, a close control of the process is mandatory, specifically SOUR reactor control. Additionally,  Inhibitors can cause serious dysfunctions in the biological reactor performance (the following parameters should be avoided at the reactor input: AOX, phenols, certain levels of heavy metals, sulfide, sulfite and cianydes). Check inhibitors levels and how to reduce in the actions of the specific parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '363',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid non- compliance in COD, a close control of the process is mandatory, specifically SOUR reactor control. Additionally,  Inhibitors COD can cause serious dysfunctions in the biological reactor performance (the following parameters should be avoided at the reactor input: AOX, phenols, certain levels of heavy metals, sulfide, sulfite and cianydes). Check inhibitors levels and how to reduce in the actions of the specific parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '364',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid non- compliance in total P, a close control of the process is mandatory, specifically SOUR reactor control. Additionally,  Inhibitors can cause serious dysfunctions in the biological reactor performance (the following parameters should be avoided at the reactor input: AOX, phenols, certain levels of heavy metals, sulfide, sulfite and cianydes). Check inhibitors levels and how to reduce in the actions of the specific parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-P']
  },
  {
    index: '365',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'To avoid non- compliance in total nitrogen, a close control of the process is mandatory, specifically SOUR reactor control. Additionally, inhibitors can cause serious dysfunctions in the biological reactor performance (the following parameters should be avoided at the reactor input: AOX, phenols, certain levels of heavy metals, sulfide, sulfite and cianydes). Check inhibitors levels and how to reduce in the actions of the specific parameter.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '366',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'To avoid non-compliance in COD, activated carbon nature should be selected according to the type of chemical parameter to be controlled. Grain particle size, pore size and carbon type should be selected according to filter manufacturer recommendations. Check if your water composition has changed and if you need to change  the carbon type or grain particle size. Remember that polar and low molecular weight substances are weakly retained on the activated carbon pore.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['COD']
  },
  {
    index: '367',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Total Chromium is biologically toxic for the activated sludge at concentrations > 1 to 100 ppm and should be avoided at the reactor input. No treatment is expected. Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Chromium, total']
  },
  {
    index: '368',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'Total biodegradable N abatment in the biological reactor, needs a combinated process of nitrification/denitrification. A special process design is needed, combining an aerated reactor for nitrification and an anoxic reactor for denitrification. On the other hand, non-biodegradable nitrogen or lack of technology for nitrification/denitrification will cause N total concentrations at the reactor and settler dicharge',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N']
  },
  {
    index: '369',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Total chromium cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Chromium, total']
  },
  {
    index: '370',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'V30´ measurements and SVI should be maintained to values < 150 ml/g in order to control a possible TSS loss at settler discharge and to avoid TSS non compliance. The solids content will not significantly affect the settling process if: the solids content is less than or equal to 150 ppm and whenever these solids do not decrease the density of the floc. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['TSS']
  },
  {
    index: '371',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Very high mixing intensity at the dosage point (G values between 200 and 300 second‐1) are recommended. Mixing times at high energy are generally in the range of 10 to 30 seconds. After this mixing operation current coagulation should be applied. Reaction basin must be fully mixed, without dead volume. Mixing pumping > 100 tank volume /h.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Arsenic',
      'Copper',
      'Antimony',
      'Nickel',
      'Silver',
      'Mercury',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '372',
    typeId: 'wastewater',
    category: ['Activated carbon filter'],
    text: 'Very low TSS content at ACF input is recommendable. Less than 2,5 ppm (< 5 NTU) for avoiding filtering contamination. So, the turbidity of the water at the inlet of this unit should be checked. If it is more than 5 NTU, intensify the treatment in the pressure sand filter',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 2'],
    parameter: ['TSS']
  },
  {
    index: '373',
    typeId: 'wastewater',
    category: ['Sedimentation tank'],
    text: 'Weir velocity should be < 4 m3/h/m',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Zinc',
      'Sulfide',
      'Arsenic',
      'Copper',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Oil and Grease',
      'Nickel',
      'Silver',
      'Mercury',
      'TSS',
      'Chromium (VI)',
      'Chromium, total',
      'Lead',
      'Cadmium'
    ]
  },
  {
    index: '374',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'When high alkalinity strong neutralization chemicals can be used, such as: mineral acids H2SO4/HCl and NaOH. Buffering should be taken into account.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '375',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'When using Al polychlorides pH control for the coagulation-flocculation reaction, is capital. pH is recommended to be maintained from 6,5 to 7,5.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Colour [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '376',
    typeId: 'wastewater',
    category: ['Collection tank'],
    text: 'When using air as oxidizing, septic control or mixer and with waters with high diluted CO&#8322; ratios, alkaline derivation to pH 8-9 can be observed due to CO&#8322; stripping.  In this situation, the addition of an acidic reagent agent must be required to adjust the pH to the optimum value of the coagulant used in the next step. This pH setting can be done in the collection tank or in the coagulation tank',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '377',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Zinc can be precipitated as hydroxide. Minimum solubility is reached at pH 9 - 9,5 to 11, using sodium hydroxide or lime as reagent. Similar results, are obtained when using both reagents. The precipitation is sensitve to pH because of the redilution of the precipitate formed. ',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Zinc']
  },
  {
    index: '378',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'Zinc cannot be complexed. This means that they cannot form complexes. A metal complex is a compound in which one or more metal atoms are bonded to one or more ligands. A ligand is an organic compound capable of binding to a metal centre via one or more atoms. Therefore, the metal has to be free so that it can be removed by physico-chemical treatment.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['Zinc']
  },
  {
    index: '379',
    typeId: 'wastewater',
    category: ['Secondary sedimentation'],
    text: 'Zinc is biologically toxic for the activated sludge at concentrations > 0,3 to 5 ppm and should be avoided at the reactor input. No treatment is expected.  Accumulation in the activated sludge should be avoided.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Zinc']
  },
  {
    index: '380',
    typeId: 'wastewater',
    category: ['Coagulation'],
    text: 'pH probe must be clean and calibrated (recommendation one a week). If the pH sensor does not measure correctly and the dosing of reagents to adjust the pH is linked to the sensor reading, a non-compliance in this parameter can occur.',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: ['pH']
  },
  {
    index: '381',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'pH range in the biological reactor needs values from 7,2 to 8,2. Usually pH correction is needed.  Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent (such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['COD']
  },
  {
    index: '382',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'pH range in the biological reactor needs values from 7,2 to 8,2. Usually pH correction is needed. Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent (such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['BOD5']
  },
  {
    index: '383',
    typeId: 'wastewater',
    category: ['Aerobic reactor'],
    text: 'pH range in the biological reactor needs values from 7,2 to 8,2.Usually pH correction is needed.  Low pH  requires an adition of a basic reagent agent (such as caustic soda) but high pH requires an adition of an acidic reagent agent ( such as sulfuric acid or hydrochloric acid)',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 3'],
    parameter: ['Total-N', 'Total-P']
  },
  {
    index: '384',
    typeId: 'wastewater',
    category: ['Flocculation'],
    text: 'pH values >8 u can affect to flocculation capacity of certain anionic polyelectrolites',
    manufacturingProcess: [
      'Continuous dyeing',
      'Exhaust dyeing',
      'Laundry',
      'Leather',
      'Overall printing',
      'Positional printing',
      'Other'
    ],
    etpType: ['ETP type 1', 'ETP type 3', 'ETP type 2'],
    parameter: [
      'Copper',
      'Total-N',
      'Cadmium',
      'Oil and Grease',
      'COD',
      'Silver',
      'Total-P',
      'Mercury',
      'Chromium, total',
      'BOD5',
      'Lead',
      'Zinc',
      'Arsenic',
      'TSS',
      'Chromium (VI)',
      'Sulfide',
      'Antimony',
      'Colour [m-1] (436 nm; 525 nm; 620 nm)',
      'Nickel'
    ]
  }
];
